module.exports = __webpack_public_path__ + "static/shareFanAir2BG-65f29ef7f0755a5f6001322b4a560df8.png";